import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import UserAvatar from '../UserAvatar/UserAvatar';
import './MentionListItem.css';

const MentionListItem = ({
  avatar,
  display,
  isCommunityMember,
  showInviteMessage
}) => (
  <div styleName="mention-list-item">
    <UserAvatar avatar={avatar} authorIsUser={false} isHyperlink={false} />
    <span styleName="mention-text-container">
      <span styleName="mention-list-name">{display}</span>
      {showInviteMessage && !isCommunityMember && (
        <span styleName="mention-invite-message">
          {`(${i18next.t('inviteToApply')})`}
        </span>
      )}
    </span>
  </div>
);

MentionListItem.propTypes = {
  avatar: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  isCommunityMember: PropTypes.bool,
  showInviteMessage: PropTypes.bool
};

MentionListItem.defaultProps = {
  showInviteMessage: false,
  isCommunityMember: false
};

export default MentionListItem;
